// extracted by mini-css-extract-plugin
export default {"ruleContent":"Styles_ruleContent__e-Jhh","ruleNumber":"Styles_ruleNumber__IYRmO"};